export const getConfigurationPrerequisitesErrors = (prerequisites) => {
    const prerequisitesKeys = Object.keys(prerequisites ?? {});
    return prerequisitesKeys.reduce((prev, key) => {
        const prerequisite = prerequisites?.[key];
        if (prerequisite?.type === 'NOT_COMPLETED' && prerequisite.message) {
            return [...prev, prerequisite.message];
        }
        return prev;
    }, []);
};
